<template>
  <nav class="navbar main-nav navbar-expand-lg ibcgp-navbar sticky-top">
    <div class="container">
      <a class="navbar-brand py-1" href="/">
        <img
          src="../../assets/images/ibcgp/logo.png"
          alt="Logo do Instituto Brasileiro de Ciências em Gestão Pública"
        >
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Abrir menu"
      >
        <span class="ti-menu"></span>
      </button>

      <div id="navbarNav" class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto align-items-lg-center">
          <li class="nav-item" :class="{ active: navHome }">
            <a class="nav-link" href="/">Início</a>
          </li>

          <li
            class="nav-item dropdown"
            :class="{ active: navSolutions }"
          >
            <a
              id="ibcgpSolucoesDropdown"
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Soluções
            </a>
            <div
              class="dropdown-menu dropdown-menu-lg-right ibcgp-dropdown-solucoes"
              aria-labelledby="ibcgpSolucoesDropdown"
            >
              <a class="dropdown-item" href="/#solucoes">
                <span class="dropdown-item-title">Visão geral na página inicial</span>
              </a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                :href="links.plataformaGestao"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="dropdown-item-title">Plataforma Rural</span>
                <span class="dropdown-item-hint">Gestão tributária e rural</span>
              </a>
              <a
                class="dropdown-item"
                :href="links.concursosPublico"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="dropdown-item-title">Concursos e processos seletivos</span>
                <span class="dropdown-item-hint">Portal do candidato</span>
              </a>
              <a
                class="dropdown-item"
                :href="links.cursosLanding"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="dropdown-item-title">Cursos e capacitação</span>
                <span class="dropdown-item-hint">Vitrine de cursos</span>
              </a>
              <a
                class="dropdown-item"
                :href="links.cursosPlataformaLogin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="dropdown-item-title">Área do aluno</span>
                <span class="dropdown-item-hint">Plataforma de cursos (login)</span>
              </a>
            </div>
          </li>

          <li class="nav-item" :class="{ active: navAbout }">
            <a class="nav-link" href="/sobre">O Instituto</a>
          </li>

          <li class="nav-item" :class="{ active: navContests }">
            <a class="nav-link" href="/concursos">Publicações Concursos</a>
          </li>

          <li class="nav-item" :class="{ active: navPublications }">
            <a class="nav-link" href="/publicacoes">Publicações</a>
          </li>

          <li class="nav-item" :class="{ active: navContact }">
            <a class="nav-link" href="/contato">Contato</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import links from '../../consts/links.js'

export default {
  data () {
    return {
      links,
      navHome: false,
      navAbout: false,
      navPublications: false,
      navContact: false,
      navContests: false,
      navSolutions: false
    }
  },

  beforeMount () {
    this.setActiveNav()
  },

  watch: {
    '$route' () {
      this.setActiveNav()
    }
  },

  methods: {
    setActiveNav () {
      const path = this.$route.path || ''
      const hash = this.$route.hash || ''

      this.navHome = path === '/' || path === ''
      this.navAbout = path === '/sobre'
      this.navContact = path === '/contato'
      this.navContests = path === '/concursos'
      this.navPublications = path === '/publicacoes' || path.indexOf('/publicacao/') === 0
      this.navSolutions = (path === '/' || path === '') && hash === '#solucoes'
    }
  }
}
</script>

<style scoped>
</style>
